// src/common/components/ProtectedRoute.js
import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { isTokenValid } from '../../app/utils/auth'

class ProtectedRoute extends Component {
  checkAuthorization = () => {
    const token = localStorage.getItem('token')
    const user = JSON.parse(localStorage.getItem('user'))

    // 1. Token missing or invalid
    if (!token || !isTokenValid(token)) {
      return 'no-token'
    }

    // 2. Role mismatch
    // const { allowedRoles = [] } = this.props

    // if (allowedRoles.length > 0) {
    //   if (!user || !allowedRoles.includes(user.userType)) {
    //     return 'wrong-role'
    //   }
    // }

    return 'authorized'
  }

  renderRoute = props => {
    const { component: ComponentProp, render } = this.props

    const auth = this.checkAuthorization()

    if (auth === 'authorized') {
      if (render) return render(props)
      if (ComponentProp) return <ComponentProp {...props} />
    }

    if (auth === 'wrong-role') {
      return <Redirect to="/unauthorized" />
    }

    return <Redirect to="/login" />
  }

  render() {
    const { component, render, ...rest } = this.props

    return <Route {...rest} render={this.renderRoute} />
  }
}

export default ProtectedRoute
